export const movimentazioneReferentiJson = [
  {
    label: "Contatto di destinazione",
    value: "destinationContact",
  },
  {
    label: "Numero di contatto",
    value: "contractNumber",
  },
];
